import type { TAsrResubmitModel } from 'app/queries/asrProxy/types/TAsrResubmitModel';

export const DEFAULT_ASR_MODEL_VALUE = 'default';

type TParams = {
  models: TAsrResubmitModel[];
  defaultModel: string;
  selectedModel: string;
};

const buildLabel = (model: TAsrResubmitModel) => {
  const provider = [model.provider, model.providerModel].filter(Boolean).join(' / ');
  const notes = [model.hasApiKey ? '' : 'no API key', model.healthy ? '' : 'health check failed'].filter(Boolean);
  return [model.name, provider && `— ${provider}`, notes.length ? `(${notes.join(', ')})` : '']
    .filter(Boolean)
    .join(' ');
};

export const buildAsrModelOptions = ({ models, defaultModel, selectedModel }: TParams) => [
  { value: DEFAULT_ASR_MODEL_VALUE, label: defaultModel ? `Default (${defaultModel})` : 'Default' },
  ...models
    .filter((model) => model.name === selectedModel || (model.healthy && model.hasApiKey))
    .map((model) => ({ value: model.name, label: buildLabel(model) })),
];
